<section>
  <!-- HEADER -->
  <div class="flex justify-between items-center mb-4">
    <h1 class="text-2xl font-bold">Main Menus</h1>

    <nav class="text-sm text-gray-600">
      <span>Dashboard</span> / <span>Main Menus</span>
    </nav>
    <div class="ml-4">
      <button
        class="btn btn-sm btn-primary"
        type="button"
        (click)="openCreate()"
      >
        Create Menu
      </button>
      <button
        class="btn btn-sm  btn-primary ml-2"
        type="button"
        (click)="openUacActions()"
      >
        UAC Action
      </button>
    </div>
  </div>

  <!-- CARD -->
  <div class="card border rounded-lg shadow-sm">
    <div class="card-body p-0">
      <div class="overflow-x-auto">
        <!-- If editingMenu is set, render the dedicated create/edit view -->
        <div *ngIf="editingMenu" class="p-4">
          <h2 class="text-lg font-semibold mb-3">
            {{ isCreate ? "Create Menu" : "Edit Menu" }}
          </h2>

          <div *ngIf="maxCharError" class="alert alert-error mb-3">
            {{ maxCharError }}
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="label">Menu Name</label>
              <input
                class="input input-bordered w-full"
                [(ngModel)]="editingMenu.menu_name"
                [attr.maxlength]="MAX_MENU_NAME"
              />
            </div>

            <div>
              <label class="label">Menu Slug</label>
              <input
                class="input input-bordered w-full"
                [(ngModel)]="editingMenu.slug"
                [attr.maxlength]="MAX_SLUG"
              />
            </div>

            <div>
              <label class="label">Parent Menu</label>
              <select
                class="select select-bordered w-full"
                [(ngModel)]="editingMenu.parent_menu_id"
              >
                <option [ngValue]="null">-</option>
                <option *ngFor="let pm of menus" [ngValue]="pm.id">
                  {{ pm.menu_name }}
                </option>
              </select>
            </div>

            <div>
              <label class="label">URL</label>
              <input
                class="input input-bordered w-full"
                [(ngModel)]="editingMenu.url"
                [attr.maxlength]="MAX_URL"
              />
            </div>

            <div>
              <label class="label">Type</label>
              <select
                class="select select-bordered w-full"
                [(ngModel)]="editingMenu.type"
              >
                <option value="side">side</option>
                <option value="top">top</option>
              </select>
            </div>

           <div>
  <label class="label">Sequence No</label>
  <input
    type="number"
    class="input input-bordered w-full"
    [(ngModel)]="editingMenu.sequence_no"
    min="1"
    max="100"
    required
  />

  <p
    *ngIf="
      editingMenu.sequence_no &&
      (editingMenu.sequence_no < 1 || editingMenu.sequence_no > 100)
    "
    class="text-red-500 text-sm mt-1"
  >
    Sequence No must be between 1 and 100.
  </p>
</div>

            <div>
              <label class="label">Active</label>
              <input
                type="checkbox"
                class="checkbox"
                [(ngModel)]="editingMenu.is_active"
              />
            </div>
          </div>

          <div class="mt-4 flex space-x-2">
            <button
              class="btn btn-primary"
              type="button"
              (click)="saveEdit()"
            >
              Save
            </button>
            <button
              class="btn btn-ghost"
              type="button"
              (click)="cancelEdit()"
            >
              Cancel
            </button>
          </div>
        </div>

        <table
          *ngIf="!editingMenu"
          class="table table-zebra w-full"
        >
          <thead class="bg-gray-50">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Parent</th>
              <th>Slug</th>
              <th>URL</th>
              <th>Type</th>
              <!-- <th>Seq</th> -->
              <!-- <th>Permissions</th> -->
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            @for (menu of menus; track menu.id ;let i = $index) {
              <!-- ================= MENU ================= -->
              <tr class="font-semibold hover:bg-gray-50">
                <td>{{ i + 1 }}</td>
                <td>{{ menu.menu_name }}</td>
                <td>-</td>
                <td>{{ menu.slug }}</td>
                <td>{{ menu.url }}</td>
                <td>{{ menu.type }}</td>
                <!-- <td>{{ menu.sequence_no }}</td> -->

                <!-- <td>{{ menu.permissions?.join(', ') || '-' }}</td> -->

                <td>
  <button
    title="View"
    class="btn btn-xs btn-circle btn-ghost text-green-600"
    (click)="viewMenu(menu.id)"
  >
    <i class="ri-eye-line"></i>
  </button>

  <button
    title="Edit"
    class="btn btn-xs btn-circle btn-ghost text-blue-600"
    (click)="openEdit(menu)"
  >
    <i class="ri-edit-line"></i>
  </button>

  <button
    title="Permissions"
    class="btn btn-xs btn-circle btn-ghost text-purple-600"
    (click)="togglePermissions(menu.id)"
  >
    <i class="ri-shield-line"></i>
  </button>

  <button
    title="Delete"
    class="btn btn-xs btn-circle btn-ghost text-red-600"
    (click)="deleteMenu(menu)"
  >
    <i class="ri-delete-bin-line"></i>
  </button>
</td>
              </tr>

              <!-- ================= PERMISSIONS EXPANDED ================= -->
              @if (expandedPermissions.includes(menu.id)) {
                @for (permission of menu.permissions || []; track permission) {
                  <tr class="hover:bg-purple-50">
                    <td></td>
                    <td
                      class="font-medium"
                      [style.paddingLeft.px]="24"
                    >
                      ↳ <span class="text-purple-700 font-semibold">{{ permission?.name || permission }}</span>
                    </td>
                    <td>{{ menu.menu_name }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>Permission</td>
                    <!-- <td>-</td>
                    <td>-</td> -->
                    <td>
  <button
    class="btn btn-xs btn-circle btn-ghost text-blue-600"
    (click)="openUacActionEdit(permission)"
  >
    <i class="ri-edit-line"></i>
  </button>

  <button
    class="btn btn-xs btn-circle btn-ghost text-red-600"
    (click)="openUacActionDelete(permission)"
  >
    <i class="ri-delete-bin-line"></i>
  </button>
</td>
                  </tr>
                }
              }

              <!-- ================= ACTIONS (submenu + actions + recursive sub_actions) ================= -->
              @if (expandedParent === menu.id) {
                @for (item of selectedActions; track item.id) {
                  <tr class="hover:bg-gray-100">
                    <td></td>

                    <!-- NAME WITH INDENT -->
                    <td
                      class="font-medium"
                      [style.paddingLeft.px]="24 + item._level * 22"
                    >
                      {{ item._level > 0 ? "↳" : "▶" }}
                      <span
                        [ngClass]="{
                          'text-blue-700 font-semibold':
                            item.type === 'submenu',
                          'text-gray-800': item.type === 'action',
                        }"
                      >
                        {{ item.menu_name || item.name }}
                      </span>
                    </td>

                    <!-- PARENT -->
                    <td>{{ item._parentName }}</td>

                    <!-- SLUG -->
                    <td>{{ item.slug || "-" }}</td>

                    <!-- URL -->
                    <td>{{ item.url || item.action_url || "-" }}</td>

                    <!-- TYPE -->
                    <td>
                      <span
                        *ngIf="item.type === 'submenu'"
                        class="badge badge-info"
                      >
                        Sub Menu
                      </span>

                      <span *ngIf="item.type === 'action'">
                        {{ item.is_component ? "Component" : "Action" }}
                      </span>
                    </td>

                    <!-- <td>-</td> -->

                    <!-- STATUS -->
                    <!-- <td>-</td> -->

                    <!-- PERMISSIONS -->
                    <!-- <td>{{ item.permissions?.join(', ') || '-' }}</td> -->

                    <!-- ACTION -->
                   <td>
  <button
    title="Edit"
    class="btn btn-xs btn-circle btn-ghost text-blue-600"
    (click)="openEdit(item)"
  >
    <i class="ri-edit-line"></i>
  </button>

  <button
    title="Manage Permissions"
    class="btn btn-xs btn-circle btn-ghost text-purple-600"
    (click)="togglePermissions(item.id)"
  >
    <i class="ri-shield-line"></i>
  </button>

  <button
    *ngIf="item.type === 'submenu'"
    title="Delete Sub Menu"
    class="btn btn-xs btn-circle btn-ghost text-red-600"
    (click)="deleteSubMenu(item)"
  >
    <i class="ri-delete-bin-line"></i>
  </button>
</td>
                  </tr>

                  <!-- ================= CHILD PERMISSIONS EXPANDED ================= -->
                  @if (expandedPermissions.includes(item.id)) {
                    @for (permission of item.permissions || []; track permission) {
                      <tr class="hover:bg-purple-50">
                        <td></td>
                        <td
                          class="font-medium"
                          [style.paddingLeft.px]="24 + (item._level + 1) * 22"
                        >
↳ <span class="text-purple-700 font-semibold">{{ permission?.name || permission }}</span>
                        </td>
                        <td>{{ item._parentName }}</td>
                        <td>-</td>
                        <td>-</td>
                        <td>Permission</td>
                        <!-- <td>-</td> -->
                        <!-- <td>-</td> -->
                       <td>
  <div class="flex items-center gap-1">

    <div class="relative group">
      <button
        class="btn btn-xs btn-circle btn-ghost text-blue-600"
        (click)="openUacActionEdit(permission)"
      >
        <i class="ri-edit-line"></i>
      </button>

      <span
        class="absolute -top-8 left-1/2 -translate-x-1/2
               bg-gray-900 text-white text-xs rounded px-2 py-1
               opacity-0 group-hover:opacity-100 transition
               whitespace-nowrap pointer-events-none z-50"
      >
        Edit
      </span>
    </div>

    <div class="relative group">
      <button
        class="btn btn-xs btn-circle btn-ghost text-red-600"
        (click)="openUacActionDelete(permission)"
      >
        <i class="ri-delete-bin-line"></i>
      </button>

      <span
        class="absolute -top-8 left-1/2 -translate-x-1/2
               bg-gray-900 text-white text-xs rounded px-2 py-1
               opacity-0 group-hover:opacity-100 transition
               whitespace-nowrap pointer-events-none z-50"
      >
        Delete
      </span>
    </div>

  </div>
</td>
                      </tr>
                    }
                  }
                }
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

